module.exports = __webpack_public_path__ + "img/urls-reports.83a44d75.png";